<template>

  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>
        <b-col
          sm="12"
          class="d-flex align-items-center mb-2"
        >
          <h4 class="mb-0 font-weight-normal">
            Tasks
          </h4>
        </b-col>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Show</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            :reduce="option => option.value"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="refInvoiceListTable"
      :items="fetchTasks"
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      empty-text="No matching records found"
      :sort-desc.sync="isSortDirDesc"
      class="position-relative"
    >

      <!-- Column: program -->
      <template #cell(program)="data">
        <b-badge variant="light-secondary">
          {{ data.value }}
        </b-badge>
      </template>

      <!-- Column: user_name -->
      <template #cell(user_name)="data">
        <b-link
          :to="{ name: 'admin-camper-edit', params: { id: data.item.camper_id} }"
        >{{ data.item.user_name }}</b-link>
      </template>

      <!-- Column: status -->
      <template #cell(status)="data">
        <b-badge
          :variant="`light-${resolveStatusVariant(data.item.status)}`"
        >
          {{ data.item.status }}
        </b-badge>
      </template>

      <!-- Column: due_date -->
      <template #cell(date)="data">
        <span>{{ data.item.date | shortDateLocal }}</span>
      </template>

    </b-table>
    <div class="mx-2 mb-2">
      <b-row>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-if="totalItems && perPage !== 'all'"
            v-model="currentPage"
            :total-rows="totalItems"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </b-card>

</template>

<script>
import { filters } from '@core/mixins/filters'
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BLink,
  BBadge,
  BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import useTaskList from './useTaskList'

import storeModule from '../studentsStoreModule'

export default {
  name: 'StudentTaskList',
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BLink,
    BBadge,
    BPagination,

    vSelect,
  },
  mixins: [filters],
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const INVOICE_APP_STORE_MODULE_NAME = 'app-student'

    // Register module
    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.registerModule(INVOICE_APP_STORE_MODULE_NAME, storeModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME)
    })

    const {
      fetchTasks,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refInvoiceListTable,

      resolveStatusVariant,

      refetchData,
    } = useTaskList(props.userData.id)

    return {
      fetchTasks,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refInvoiceListTable,

      resolveStatusVariant,

      refetchData,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
